import { add } from 'date-fns';

import { formatByLocale } from 'utils/date';

import Chip from '@sdb/ui/atoms/Chip';
import { Box } from '@mui/material';

import { YearChipSelection, SelectedYearChip } from '../../enum';

interface ChipsProps {
  selectedYearChip: string;
  onChipClick: (ChipType: SelectedYearChip) => void;
}

export default function YearChips({
  selectedYearChip,
  onChipClick
}: ChipsProps) {
  return (
    <Box display="flex" gap={2}>
      <Chip
        shape="pill"
        variant={
          selectedYearChip === YearChipSelection.LAST_YEAR
            ? 'filled'
            : 'outlined'
        }
        color="primary"
        onClick={() => onChipClick(YearChipSelection.LAST_YEAR)}
        label={formatByLocale(
          add(new Date(), {
            years: -1
          }),
          'yyyy'
        )}
      />
      <Chip
        shape="pill"
        variant={
          selectedYearChip === YearChipSelection.THIS_YEAR
            ? 'filled'
            : 'outlined'
        }
        color="primary"
        onClick={() => onChipClick(YearChipSelection.THIS_YEAR)}
        label={formatByLocale(new Date(), 'yyyy')}
      />
      <Chip
        shape="pill"
        variant={
          selectedYearChip === YearChipSelection.NEXT_YEAR
            ? 'filled'
            : 'outlined'
        }
        color="primary"
        onClick={() => onChipClick(YearChipSelection.NEXT_YEAR)}
        label={formatByLocale(
          add(new Date(), {
            years: 1
          }),
          'yyyy'
        )}
      />
    </Box>
  );
}
